import React from 'react'
import { t } from '@lingui/core/macro'
import { getBankNames } from '../../types/Bank'
import FormSelect, { FormSelectItem } from './FormSelect'

interface BankSelectProps {
    label: string
    value: string
    onChange: (value: string) => void
    errorMessage?: string
}

const BankSelect = ({ label, value, onChange, errorMessage }: BankSelectProps) => {
    return <FormSelect
        label={label}
        value={value}
        items={getBankNames().map(bankName => ({ name: bankName.bank, value: bankName.name })) as FormSelectItem[]}
        placeholder={t`Другой банк`}
        searchPlaceholder={t`Поиск по названию банка`}
        onChange={onChange}
        errorMessage={errorMessage}
    />
}

export default BankSelect
